import {
    Component,
    Inject,
    OnInit,
    ViewEncapsulation,
    Output,
    EventEmitter,
} from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { RecordAction } from "../../../../../../../../../utils/enums/shared/enums";

import { UserService } from "../../../../../../../../../services/admon/user.service";
import { User } from "../../../../../../../../../utils/types/admon/user.type";
import { RoleDatasource } from "../../../../../../../../../utils/datasources/roles/role.datasource";
import { RoleService } from "../../../../../../../../../services/roles/role.service";
import { Pagination } from "../../../../../../../../../utils/types/shared/pagination";
import { Role } from "../../../../../../../../../utils/types/roles/role.type";
import { TranslateService } from "@ngx-translate/core";
import { ValidationService } from "../../../../../../../../../services/validation/validation.service";

@Component({
    selector: "wtf-user-form",
    templateUrl: "./user-form.component.html",
    styleUrls: ["./user-form.component.scss"],
    encapsulation: ViewEncapsulation.None,
    providers: [ValidationService],
})
export class UserFormComponent implements OnInit {
    user: User = new User();
    roleItem: Role;
    dialogTitle: string;
    userForm: FormGroup;
    action: RecordAction;
    roles: any = [];
    actionInput: any;
    recordAction = RecordAction;
    form: FormGroup;

    private passwordChange = false;
    public policy: boolean = false;

    private strongPasswordRegex: RegExp =
        /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@#$%^&+=!]).{8,}$/;

    callback: (user) => void;

    addItem(roleChip) {
        const found = false;

        // Check if exists
        for (const rol of this.user.roles) {
            if (rol.roleId === roleChip.value) {
                return;
            }
        }

        if (found) {
            return;
        }

        this.roleItem = new Role();
        this.roleItem.userId =
            this.action === RecordAction.Add ? 0 : this.user.id;
        this.roleItem.roleId = roleChip.value;
        this.user.roles.push(this.roleItem);
    }

    deleteItem(roleChip) {
        let index: number;

        let i = 0;
        for (const rol of this.user.roles) {
            if (rol.roleId === roleChip.value) {
                index = i;
            }
            i++;
        }

        if (i > 0) {
            this.user.roles.splice(index, 1);
        }
    }

    showPolicy() {
        this.policy = true;
    }

    hidePolicy() {
        this.policy = false;
    }

    constructor(
        public dialogRef: MatDialogRef<UserFormComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any,
        private translateService: TranslateService,
        private validationService: ValidationService
    ) {
        this.translateService.setDefaultLang("en");
        this.translateService.use(localStorage.getItem("language") || "en");
        this.action = data.action;
        this.callback = data.callback;

        if (
            this.action === RecordAction.Update ||
            this.action === RecordAction.View
        ) {
            this.user = data.user;

            // refactor role list
            const roles = this.user.roles;
            this.user.roles = [];

            for (const rol of roles) {
                this.roleItem = new Role();
                this.roleItem.userId = this.user.id;
                this.roleItem.roleId = rol.id;
                this.roleItem.name = rol.name;
                this.user.roles.push(this.roleItem);
            }

            this.dialogTitle = this.user.firstName;

            this.user.passwordCompare = this.user.password;
        } else {
            this.dialogTitle = "Nuevo Usuario";
            this.dialogTitle = this.translateService.instant(this.dialogTitle);
            this.user.roles = [];
        }

        for (const role of data.roles) {
            if (role.active) {
                this.roles.push({ display: role.name, value: role.id });
            }
        }

        this.userForm = this.createForm();
    }

    ngOnInit() {
        this.actionInput = this.action;
    }

    isControlValid(form: FormGroup, field: string) {
        return this.validationService.isValidField(form, field);
    }

    getErrorMessage(form: FormGroup, field: string, text: string) {
        return this.validationService.getErrorMessage(form, field, text);
    }

    createForm() {
        this.form = new FormGroup({
            username: new FormControl(this.user.username, [
                Validators.required,
                Validators.pattern("^[A-Za-z0-9_@./#&+-]*$"),
            ]),
            firstName: new FormControl(this.user.firstName, [
                Validators.required,
                Validators.pattern("^[a-zA-ZñÑÀ-ú_]+( [a-zA-ZñÑÀ-ú_]+)*$"),
            ]),
            lastName: new FormControl(this.user.lastName, [
                Validators.required,
                Validators.pattern("^[a-zA-ZñÑÀ-ú_]+( [a-zA-ZñÑÀ-ú_]+)*$"),
            ]),
            email: new FormControl(this.user.email, [
                Validators.required,
                Validators.email,
            ]),
            password: new FormControl(null, []),
            active: new FormControl(this.user.active),
            has2FA: new FormControl(this.user.has2FA),
            auth_channel: new FormControl(this.user.auth_channel),
        });

        const form = this.form;

        form.controls["username"].valueChanges.subscribe(
            (value) => (this.user.username = value)
        );

        form.controls["firstName"].valueChanges.subscribe(
            (value) => (this.user.firstName = value)
        );

        form.controls["lastName"].valueChanges.subscribe(
            (value) => (this.user.lastName = value)
        );

        form.controls["email"].valueChanges.subscribe(
            (value) => (this.user.email = value)
        );

        form.controls["password"].valueChanges.subscribe((value) => {
            this.user.password = value;
            if (this.action == RecordAction.Update) {
                this.user.passwordChange = true;
            }

            if (this.user.password.length > 0) {
                form.controls["password"].setValidators([
                    Validators.pattern(this.strongPasswordRegex),
                ]);
            }
        });

        form.controls["active"].valueChanges.subscribe(
            (value) => (this.user.active = value)
        );

        form.controls["has2FA"].valueChanges.subscribe(
            (value) => (this.user.has2FA = value)
        );

        form.controls["auth_channel"].valueChanges.subscribe(
            (value) => (this.user.auth_channel = value)
        );

        return form;
    }

    saveUser() {
        if (this.userForm.invalid) {
            return;
        }

        delete this.user.isNewUser;

        this.callback(this.user);
    }
}
